import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                     What does a SAP business consultant do?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>SAP consultants develop and implement SAP systems for business clients. They assess the specific business requirements of clients, develop tailored SAP solutions, and seamlessly incorporate SAP applications into their current IT systems.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    Does SAP offer consulting services?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Yes, SAP offers consulting services with expert guidance, regardless of your size, industry, or SAP solution. </p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;